module.exports = __webpack_public_path__ + "media/images/front/home_1-18a3a0b57ef7f11ad974a04f01e57377.jpg";